import {NetworkService} from "./NetworkService";
import {sessionStore} from "../store/sessionStore";
import StoreService from "./StoreService";

export class LoginServices {
  static async login(login) {
    try {

      const loginResponse = await NetworkService.request({
        url: "users/login",
        method: "POST",
        data: login,
      });
      sessionStore.userId = loginResponse.id;
      sessionStore.token = loginResponse.token;
      sessionStore.isTokenExpired = false;
      sessionStore.isLoggedIn = true
    } catch (e) {
      return e
    }
  }

  static async logout() {
    await NetworkService.request({
      url: "users/logout",
      method: "POST",
    });
    StoreService.clearStore()
    window.location.href = "/login";
  }

  static expireSession() {
    StoreService.clearStore();
  }
  static verifySession() {
    return sessionStore.isLoggedIn
  }
  static currentUser() {
    return NetworkService.request({
      url: "users/current",
      method: "GET",
    })
  }
}

